// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_total_number_of_cases_detected_in_incoming_emails_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of cases detected in incoming emails.`)
};

const en_us2_total_number_of_cases_detected_in_incoming_emails_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of cases detected in incoming emails.`)
};

const de_de2_total_number_of_cases_detected_in_incoming_emails_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtanzahl an Vorgängen, welche in eingehenden E-Mails erkannt wurden.`)
};

const en_total_number_of_cases_detected_in_incoming_emails_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total number of cases detected in incoming emails.`)
};

const de_total_number_of_cases_detected_in_incoming_emails_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtanzahl an Vorgängen, welche in eingehenden E-Mails erkannt wurden.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const total_number_of_cases_detected_in_incoming_emails_1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.total_number_of_cases_detected_in_incoming_emails_1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("total_number_of_cases_detected_in_incoming_emails_1", locale)
	if (locale === "en-GB") return en_gb2_total_number_of_cases_detected_in_incoming_emails_1(inputs)
	if (locale === "en-US") return en_us2_total_number_of_cases_detected_in_incoming_emails_1(inputs)
	if (locale === "de-DE") return de_de2_total_number_of_cases_detected_in_incoming_emails_1(inputs)
	if (locale === "en") return en_total_number_of_cases_detected_in_incoming_emails_1(inputs)
	return de_total_number_of_cases_detected_in_incoming_emails_1(inputs)
};
export { total_number_of_cases_detected_in_incoming_emails_1 as "Total number of cases detected in incoming emails." }